import shopifyHelpers from 'Platforms/shopify/helpers.ts';

window.Convermax = window.Convermax || {};
window.Convermax.Shopify = window.Convermax.Shopify || {};

window.Convermax.Shopify = {
  ...(window.Convermax.Shopify || {}),
  ...shopifyHelpers,
};
